




























	import Vue from 'vue';
    import ProgressComp from "./ProgressComp.vue";
    import InsightsComp from "./InsightsComp.vue";
    import ErfolgeComp from "../erfolge/ErfolgeComp.vue";

    export default Vue.extend({
        name: "ProgressOverviewComp",
        props: ['user', 'ownProfile'],
        data: () => ({
            progressCompNames: ["Weekly Progress", "Trophäen", 'Erfolge'],
            progressComps: [ProgressComp, InsightsComp, ErfolgeComp],
        })

    })
